import React, { useRef } from "react";

const ReadingPaneModal = (props) => {
  const { isAccordion, documentListing } = props;
  const modalRef = useRef();

  const onClose = () => {
    if (modalRef.current) {
      modalRef.current.classList.remove('show');
      documentListing.style.display = 'block';
    }
  }

  return (
    <div className="reading-pane-modal" id="readingPaneModal" ref={modalRef}>
       <div className="reading-pane-modal__container">
            <div className="reading-pane-modal__header">
                <span className="reading-pane-modal__title">Reading Pane</span>
                <button type="button" className="reading-pane-modal__close js-reading-pane-close" onClick={onClose}><span aria-hidden="Close">x</span></button>
            </div>
       </div>

       <div className="reading-pane-modal__body" id="readingPaneModalBody"></div>
    </div>
  );
};

export default ReadingPaneModal;
